export const styles = {
  container: {
    padding: '2em',
  },
  tableContainer: {
    marginTop: '2em',
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
  },
  button: {
    marginRight: '1em',
    fontSize: '1rem',
    borderRadius: '2em',
    padding: '0.5em 2em',
    textTransform: 'none',
  },
  chip: {
    borderRadius: '1em',
    '& .MuiChip-label': {
      padding: '0.5em 1em',
    },
  },
  published: {
    backgroundColor: '#4caf50',
    color: 'white',
  },
  unpublished: {
    backgroundColor: '#ff9800',
    color: 'white',
  },
  actionButton: {
    minWidth: '100px',
    textTransform: 'none',
  },
  actionButtons: {
    display: 'flex',
    gap: '0.5em',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4em',
  },
  spinner: {
    marginBottom: '1em',
  },
  loadingText: {
    color: 'text.secondary',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4em',
  },
  errorIcon: {
    fontSize: '3rem',
    color: 'error.main',
    marginBottom: '1em',
  },
  errorText: {
    color: 'text.primary',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginBottom: '0.5em',
  },
  errorMessage: {
    color: 'text.secondary',
    marginBottom: '1.5em',
    textAlign: 'center',
  },
  retryButton: {
    borderRadius: '2em',
    padding: '0.5em 2em',
    textTransform: 'none',
  },
  noFilesContainer: {
    textAlign: 'center',
    padding: '2em',
  },
};